import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import authAxios from 'src/modules/shared/axios/authAxios';

export default class WorkflowLaunchService {
  static async create(data) {
    const body = { data };
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.post(
      `/tenant/${tenantId}/workflow-launch`,
      body,
    );
    return response.data;
  }

  static async update(id, data) {
    const body = { id, data };
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.put(
      `/tenant/${tenantId}/workflow-launch/${id}`,
      body,
    );
    return response.data;
  }

  static async destroyAll(ids) {
    const params = { ids };
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.delete(
      `/tenant/${tenantId}/workflow-launch`,
      { params },
    );
    return response.data;
  }

  static async publish(id) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.post(
      `/tenant/${tenantId}/workflow-launch/${id}/publish`,
    );
    return response.data;
  }

  static async archive(id) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.post(
      `/tenant/${tenantId}/workflow-launch/${id}/archive`,
    );
    return response.data;
  }

  static async find(id) {
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.get(
      `/tenant/${tenantId}/workflow-launch/${id}`,
    );
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = { filter, orderBy, limit, offset };
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.get(
      `/tenant/${tenantId}/workflow-launch`,
      { params },
    );
    return response.data;
  }

  static async import(values, importHash) {
    const body = { data: values, importHash };
    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.post(
      `/tenant/${tenantId}/workflow-launch/import`,
      body,
    );
    return response.data;
  }
}
